import type { NavSection } from "../components/Shell.tsx";
import { isNotetakerAdmin } from "./roles.ts";
import { NOTETAKER_PAGES, type NotetakerGroup } from "./pages.ts";

const GROUPS: readonly { id: NotetakerGroup; label: string }[] = [
  { id: "work", label: "Work" }, { id: "analysis", label: "Analysis" }, { id: "admin", label: "Admin" },
];

/** The Notetaker rail (D15): Work and Analysis for anyone who can see the module, Admin for Notetaker.Admin only. */
export function notetakerNav(roles: readonly string[]): NavSection[] {
  const shown = (g: NotetakerGroup) => g !== "admin" || isNotetakerAdmin(roles);
  return GROUPS.filter((g) => shown(g.id)).map((g) => ({
    id: g.id, label: g.label,
    items: NOTETAKER_PAGES.filter((p) => p.group === g.id).map((p) => ({ to: p.path, label: p.label, section: "notetaker", icon: p.icon })),
  }));
}

/** Where the entry link and the bare /notetaker go: the executive summary for an admin, otherwise My week. */
export const landingFor = (roles: readonly string[]): string => (isNotetakerAdmin(roles) ? "/notetaker/admin" : "/notetaker/week");
